import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IntegrationType, Recipe, RecipeTemplate } from '@pdqdev/pdq-shared/dist/entities';
import { ToastService } from '@storybook/services/toast/toast.service';
import { finalize } from 'rxjs/operators';
import { IntegrationsService } from '@services/integrations/integrations.service';
import { RecipeEditorComponent } from '../../recipe-editor/recipe-editor.component';

@Component({
  selector: 'recipe-template',
  templateUrl: './recipe-template.component.html',
  styleUrls: ['./recipe-template.component.scss'],
  standalone: false,
})
export class RecipeTemplateComponent implements OnInit, OnChanges {
  @Input() recipeTemplate: RecipeTemplate;
  @Input() integrationType: IntegrationType;
  dialogRef: MatDialogRef<RecipeEditorComponent>;
  textElements: { text: string; isBold: boolean }[] = [];
  isLoading: boolean;
  constructor(
    private dialog: MatDialog,
    public integrationsService: IntegrationsService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges): void {}

  addRecipe() {
    if (this.recipeTemplate.dynamicPartsConfig) {
      this.dialogRef = this.dialog.open(RecipeEditorComponent, {
        backdropClass: 'global_modal_overlay_subdued',
        panelClass: 'overflow-visible-class',
        data: { recipeTemplate: this.recipeTemplate, integrationType: this.integrationType },
      });
    } else {
      this.addReadonlyRecipe();
    }
  }

  addReadonlyRecipe() {
    const recipe = new Recipe();
    recipe.template = this.recipeTemplate;
    recipe.isActive = true;
    this.isLoading = true;
    this.integrationsService
      .postRecipe(recipe, this.integrationType)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
      )
      .subscribe(
        (updatedRecipe) => {
          this.toastService.showToast({ mode: 'success', message: 'Recipe added' });
        },
        (err) => {
          console.log(err);
          this.toastService.showToast({ mode: 'error', message: 'Failed to add recipe' });
        },
      );
  }
}
